import React from 'react';
import { compose } from 'recompose';

import SingleChannelView from '../SingleChannelView';
import { withChatContextProviderReady } from '../../context/ChatContext/withChatContextProvider';

import {
  ChatContainer,
  ChannelContainer,
} from './styles';

const ChatMobileView = () => (
  <ChatContainer>
    <ChannelContainer>
      <SingleChannelView isMobileView />
    </ChannelContainer>
  </ChatContainer>
);

export default compose(
  withChatContextProviderReady,
)(ChatMobileView);
